import * as tslib_1 from "tslib";
import { Item } from './item';
import { Value } from './value';
var DynamicValue = (function (_super) {
    tslib_1.__extends(DynamicValue, _super);
    function DynamicValue() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DynamicValue.prototype.cond = function (thenExpr, elseExpr) {
        thenExpr = Item.of(thenExpr);
        elseExpr = Item.of(elseExpr);
        return new Item.CondExpr(this, thenExpr, elseExpr);
    };
    DynamicValue.prototype.or = function (that) {
        that = Item.of(that);
        return new Item.LorExpr(this, that);
    };
    DynamicValue.prototype.and = function (that) {
        that = Item.of(that);
        return new Item.LandExpr(this, that);
    };
    DynamicValue.prototype.bor = function (that) {
        that = Item.of(that);
        return new Item.BorExpr(this, that);
    };
    DynamicValue.prototype.bxor = function (that) {
        that = Item.of(that);
        return new Item.BxorExpr(this, that);
    };
    DynamicValue.prototype.band = function (that) {
        that = Item.of(that);
        return new Item.BandExpr(this, that);
    };
    DynamicValue.prototype.lt = function (that) {
        that = Item.of(that);
        return new Item.LtExpr(this, that);
    };
    DynamicValue.prototype.le = function (that) {
        that = Item.of(that);
        return new Item.LeExpr(this, that);
    };
    DynamicValue.prototype.eq = function (that) {
        that = Item.of(that);
        return new Item.EqExpr(this, that);
    };
    DynamicValue.prototype.ne = function (that) {
        that = Item.of(that);
        return new Item.NeExpr(this, that);
    };
    DynamicValue.prototype.ge = function (that) {
        that = Item.of(that);
        return new Item.GeExpr(this, that);
    };
    DynamicValue.prototype.gt = function (that) {
        that = Item.of(that);
        return new Item.GtExpr(this, that);
    };
    DynamicValue.prototype.plus = function (that) {
        that = Item.of(that);
        return new Item.AddExpr(this, that);
    };
    DynamicValue.prototype.minus = function (that) {
        that = Item.of(that);
        return new Item.SubExpr(this, that);
    };
    DynamicValue.prototype.times = function (that) {
        that = Item.of(that);
        return new Item.MulExpr(this, that);
    };
    DynamicValue.prototype.divide = function (that) {
        that = Item.of(that);
        return new Item.DivExpr(this, that);
    };
    DynamicValue.prototype.modulo = function (that) {
        that = Item.of(that);
        return new Item.ModExpr(this, that);
    };
    DynamicValue.prototype.not = function () {
        return new Item.LnotExpr(this);
    };
    DynamicValue.prototype.bnot = function () {
        return new Item.BnotExpr(this);
    };
    DynamicValue.prototype.neg = function () {
        return new Item.NegExpr(this);
    };
    DynamicValue.prototype.pos = function () {
        return new Item.PosExpr(this);
    };
    DynamicValue.prototype.inv = function () {
        return new Item.DivExpr(Item.Num.One, this);
    };
    DynamicValue.prototype.toAny = function () {
        return this;
    };
    return DynamicValue;
}(Value));
export { DynamicValue };
Item.DynamicValue = DynamicValue;
//# sourceMappingURL=data:application/json;base64,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